import store from '../reducers/storeRegistration';
import reportActionCreators from '../actions/reportActionCreators';
import issueActionCreators from '../actions/issueActionCreators';
import jobActionCreators from '../actions/jobActionCreators';
import formActionCreators from '../actions/formActionCreators';
import formModalActionCreators from '../actions/formModalActionCreators';
const actionCreators = {
  reportActionCreators,
  issueActionCreators,
  jobActionCreators,
  formActionCreators,
  formModalActionCreators
};

/**
 * Re-evaluates format for the active record (so it picks up latest cache, etc.)
 * and dispatches the new format so the UI re-renders with fresh data.
 * Uses id from state[entityName].active (the currently displayed record).
 */
export const evaluate = async (entity, entityName) => {
  var _state$entityName;
  const entityActions = actionCreators["".concat(entityName, "ActionCreators")];
  const state = store.getState();
  const _ref = ((_state$entityName = state[entityName]) === null || _state$entityName === void 0 ? void 0 : _state$entityName.active) || {},
    id = _ref.id;
  if (!id) {
    return null;
  }
  const action = typeof (entityActions === null || entityActions === void 0 ? void 0 : entityActions.forceRerender) === 'function' ? entityActions.forceRerender(id) : null;
  if (!action) {
    return null;
  }
  await store.dispatch(action);
  return null;
};
export default {
  evaluate
};